<template>
  <div class="related">
    <div class="related__head">
      <h2 class="related__title">{{ title }}</h2><!-- /.related__title -->
    </div><!-- /.related__head -->

    <div class="related__body">
      <b-row>
        <b-col lg="4" v-for="(recipe,index) in similarRecipes" :key="index">
          <b-card no-body class="card-article card-articles--alt">
            <!-- Card image -->
            <div class="card-img-top">
              <a :href="recipe.id" @click="loadRecipePage($event)"
                :style="'background-image: url(' + recipe.img + ');'" v-if="recipe.img">
              </a>
            </div>
            <!-- Card body -->
            <b-card-body>
              <b-card-title class="h2 mb-0">
                <a :href="recipe.id" @click="loadRecipePage($event)">{{ recipe.title }}</a>
              </b-card-title>
              <small class="text-muted">{{ authorBy }} {{ recipe.author }}, {{ recipe.date_created }}</small>
              <b-card-text class="mt-4 js-truncate-summary" v-html="recipe.description"></b-card-text>
              <div class="d-flex justify-content-between align-items-center">
                <a :href="recipe.id" class="btn btn-link px-0" @click="loadRecipePage($event)">{{ viewRecipe }}</a>

                <div class="icon-actions">
                  <a href="#" class="like active" @click="handleLike($event, index, recipe)">
                    <i class="ni ni-like-2"></i>
                    <span class="text-muted">{{ recipe.likes }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-chat-round"></i>
                    <span class="text-muted">{{ recipe.comments }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-curved-next"></i>
                    <span class="text-muted">{{ recipe.shares }}</span>
                  </a>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div><!-- /.related__body -->
  </div><!-- /.related -->
</template>
<script>
  import { ellipsis } from 'ellipsed';

  export default {
    name: 'similar-recipes',
    props: ['recipeId'],
    components: {
    },
    data() {
      return {
        data: null,
        similarRecipes: []
      }
    },
    computed: {
      apiKey() {
        return this.data && this.data.api_key;
      },
       recipeData() {
        return this.$store.state.recipes.current
      },
      title() {
        return this.data && this.data.recipes.similar_title;
      },
      similarIds() {
        return this.recipeData && this.recipeData.similar_recipes;
      },
      fileRecipesData() {
        return this.data && this.$store.state.recipes;
      },
      authorBy() {
        return this.data && this.data.recipes.author_by;
      },
      viewRecipe() {
        return this.data && this.data.recipes.view_button
      }
    },
    methods: {
      onCreated() {
        let ids = []
        let recipes = []
        if(this.similarIds){
          this.similarIds.forEach(function(item) {
            ids.push(item.id);
          })
        }

        const allRecipes = this.$store.state.recipes

        ids.join(',');

        for (var i = 0; i < ids.length; i++) {
          const recipe = allRecipes.find(x => x.id === ids[i])
          recipes.push(recipe)
        }
        this.similarRecipes = recipes
      },
      loadRecipePage(event) {
        event.preventDefault();

        let route = 'recipe';
        const button = event.target.closest('a');

        if (button) {
          this.$router.push({
            path: route,
            query: {
              id: button.getAttribute('href')
            }
          }).catch(() => {});

          scroll({
            top: 0,
            behavior: "smooth"
          });
        }
      }
    },
    created(){
      this.onCreated();
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
